import * as React from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
  Typography,
  Stack,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import { Images } from "../../assets/common";
import { fullName } from "../../constants/function";
import { useHistory } from "react-router-dom";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function BlockConfirmPopup({
  open,
  handleClose,
  user,
  onHandleBlock,
  type,
}) {
  const history = useHistory();
  const [status, setStatus] = React.useState(null);
  React.useEffect(function () {}, []);
  return (
    <Box>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#1A1A1A",
            boxShadow: "none",
            color: "#ffffff",
            borderRadius: 16,

            width: "444px",
            // height: "291px",
          },
        }}
      >
        <DialogContent sx={{ padding: 0 }}>
          <Stack
            sx={{ padding: "16px" }}
            spacing={1}
            direction="row"
            alignItems="center"
          >
            <img
              style={{ width: "28px", height: "28px", borderRadius: "50%" }}
              src={user?.user?.profileImg?.filePath || Images.default_user}
              alt=""
            />
            <Typography
              onClick={() => {
                history.push(`/app/ArtistProfile/${user["user"]["_id"]}`);
                handleClose();
              }}
              className="fs-20 _cp"
              sx={{ color: "#00C3FD" }}
            >
              {fullName(user?.user)}
            </Typography>
          </Stack>
          <Divider sx={{ borderColor: "#1E1E1E" }} />
          <Stack sx={{ padding: "16px" }}>
            <Typography className="fs-17">
              Please select from below options:
            </Typography>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                onChange={(e) => setStatus(e.target.value)}
              >
                {/* NOTE:Remove user from group chat*/}
                {/* {type !== "direct" ? (
                  <FormControlLabel
                    value="removed"
                    control={<Radio />}
                    label="Remove this user from chat"
                  />
                ) : null} */}
                <FormControlLabel
                  value={user?.isBlocked ? "active" : "blocked"}
                  control={<Radio />}
                  label={
                    user?.isBlocked ? "Unblock this user" : "Block this user"
                  }
                />
              </RadioGroup>
            </FormControl>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ marginTop: "30px" }}
            >
              <Button
                sx={{ width: "150px !important", height: "50px !important" }}
                className="fs-17"
                onClick={() => handleClose()}
              >
                Cancel
              </Button>
              <Button
                disabled={status === null}
                sx={{ width: "150px !important", height: "50px !important" }}
                className="fs-17"
                variant="contained"
                color="primary"
                onClick={() => onHandleBlock(user["user"], status)}
              >
                Apply
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
